
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/minimap.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-components-minimap-demo-xflow-components-minimap"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/minimap.en.md?type=demo')
};